




import React from 'react'
import './Networking.css'



const Networking:React.FC = () => {


  return (


    <div className=' w-screen overflow-hidden p-10 custom-networking-container '>

      
    <div className=' flex flex-col items-center justify-center mx-auto max-w-[800px]'>
        <div className=' sm:text-lg md:text-lg lg:text-3xl xl:text-3xl  text-black font-sans '>
            <h3>Mentorship & Networking Workshops</h3>
            </div>

            <div className=' sm:text-lg md:text-lg lg:text-lg xl:text-lg text-black text-center font-mono w-[70%] mt-10'>
                <p>Athletes receive life skills training, 
                    college readiness tools, and opportunities to network with coaches, 
                    agents, and mentors who care about their future.</p>
            </div>

    </div>



</div>



  )
}




export default Networking
